// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 500px) {\n.add-phone__phone-code .sk-select {\n    padding-right: 0;\n}\n.add-phone__phone-code .sk-select__arrow {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
